/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddCrmOpportunityNoteInput
 */
export interface AddCrmOpportunityNoteInput {
    /**
     * 
     * @type {string}
     * @memberof AddCrmOpportunityNoteInput
     */
    body?: string;
}

/**
 * Check if a given object implements the AddCrmOpportunityNoteInput interface.
 */
export function instanceOfAddCrmOpportunityNoteInput(value: object): value is AddCrmOpportunityNoteInput {
    return true;
}

export function AddCrmOpportunityNoteInputFromJSON(json: any): AddCrmOpportunityNoteInput {
    return AddCrmOpportunityNoteInputFromJSONTyped(json, false);
}

export function AddCrmOpportunityNoteInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCrmOpportunityNoteInput {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function AddCrmOpportunityNoteInputToJSON(json: any): AddCrmOpportunityNoteInput {
    return AddCrmOpportunityNoteInputToJSONTyped(json, false);
}

export function AddCrmOpportunityNoteInputToJSONTyped(value?: AddCrmOpportunityNoteInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
    };
}

